import { useRef } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { NS } from '../../../../models/I18n';
import Button from '../../../../shared/components/buttons/Button';
import { Lead } from '../../../../models/Lead';
import { Question } from '../../../../shared/components/forms/Question';

export interface LeadInfoFormProps {
  visible: boolean;
  isLoading: boolean;
  submitForm: (lead: Lead) => Promise<void>;
}

function LeadInfoForm({ visible, isLoading, submitForm }: LeadInfoFormProps) {
  const { t } = useTranslation(NS.Eligibility);
  const ref = useRef<HTMLFormElement>(null);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (ref?.current) {
      window.gtag?.('event', 'generate_lead', {
        event_category: 'engagement',
        event_label: 'eligibility',
      });
      const data = new FormData(ref.current);
      submitForm({
        first_name: data.get('first_name') as string,
        last_name: data.get('last_name') as string,
        phone_number: data.get('phone_number') as string,
        email: data.get('email') as string,
      });
    }
  };
  return (
    <form className={cn({ hidden: !visible })} ref={ref} onSubmit={onSubmit}>
      <Question>{t('leadInfo.please-fill')}</Question>
      <div className="mt-3">
        <div className="w-full lg:w-2/5">
          <label htmlFor="first_name" className="float-left mb-1 inline-block text-gray-600">
            {t('leadInfo.first-name')}
          </label>
          <input
            id="first_name"
            name="first_name"
            className="block w-full rounded border-gray-400 text-gray-600"
            type="text"
            required
          />
        </div>
        <div className="mt-2 w-full lg:w-2/5">
          <label className="float-left mb-1 inline-block text-gray-600">{t('leadInfo.last-name')}</label>
          <input
            id="last_name"
            name="last_name"
            className="block w-full rounded border-gray-400 text-gray-600"
            type="text"
            required
          />
        </div>
        <div className="mt-2 w-full lg:w-2/5">
          <label className="float-left mb-1 inline-block text-gray-600">{t('leadInfo.phone-number')}</label>
          <input
            id="phone_number"
            name="phone_number"
            className="block w-full rounded border-gray-400 text-gray-600"
            type="text"
            required
          />
        </div>
        <div className="mt-2 w-full lg:w-2/5">
          <label className="float-left mb-1 inline-block text-gray-600">{t('leadInfo.email-address')}</label>
          <input
            id="email"
            name="email"
            className="block w-full rounded border-gray-400 text-gray-600"
            type="email"
            required
          />
        </div>
      </div>
      <Button
        type="submit"
        className="mt-[40px] w-[200px] bg-brand-blue text-base text-classic-light"
        isLoading={isLoading}
      >
        {t(`${NS.Eligibility}:eligibleProgramCards.submit`)}
      </Button>
    </form>
  );
}

export default LeadInfoForm;
